import { render, staticRenderFns } from "./QuizResultMaster.vue?vue&type=template&id=61fc2882&scoped=true&"
import script from "./QuizResultMaster.vue?vue&type=script&lang=js&"
export * from "./QuizResultMaster.vue?vue&type=script&lang=js&"
import style0 from "./QuizResultMaster.vue?vue&type=style&index=0&id=61fc2882&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fc2882",
  null
  
)

export default component.exports